import { AbsoluteLightValues, AbsoluteDarkValues } from '../../absolutes/absolutes/index.js';
import { AccentsLightValues, AccentsLightIllustrationsValues, AccentsDarkValues, AccentsDarkIllustrationsValues } from '../../accents/accents/index.js';
import { BackgroundsLightValues, BackgroundsDarkValues } from '../../backgrounds/backgrounds/index.js';
import { TextsLightValues, TextsDarkValues } from '../../texts/texts/index.js';
import { PremiumLightValues, PremiumDarkValues } from '../../premium/premium/index.js';
import { StatusesLightValues, StatusesDarkValues } from '../../statuses/statuses/index.js';
import { ShadowLightValues, ShadowDarkValues } from '../../shadows/shadows/index.js';
import { MarketsLightValues, MarketsDarkValues } from '../../market/market/index.js';
import { ControlsLightValues, ControlsDarkValues } from '../../controls/controls/index.js';
import { ExternalBrandLightValues, ExternalBrandDarkValues } from '../../externalBrand/externalBrand/index.js';
import { TransformerLightValues, TransformerDarkValues } from '../../transformer/transformer/index.js';

const ThemeLightValues = Object.freeze({
    accents: AccentsLightValues,
    accentIllustrations: AccentsLightIllustrationsValues,
    backgrounds: BackgroundsLightValues,
    texts: TextsLightValues,
    premium: PremiumLightValues,
    statuses: StatusesLightValues,
    shadows: ShadowLightValues,
    markets: MarketsLightValues,
    controls: ControlsLightValues,
    absolutes: AbsoluteLightValues,
    externalBrand: ExternalBrandLightValues,
    transformer: TransformerLightValues,
});
const ThemeDarkValues = Object.freeze({
    accents: AccentsDarkValues,
    accentIllustrations: AccentsDarkIllustrationsValues,
    backgrounds: BackgroundsDarkValues,
    texts: TextsDarkValues,
    premium: PremiumDarkValues,
    statuses: StatusesDarkValues,
    shadows: ShadowDarkValues,
    markets: MarketsDarkValues,
    controls: ControlsDarkValues,
    absolutes: AbsoluteDarkValues,
    externalBrand: ExternalBrandDarkValues,
    transformer: TransformerDarkValues,
});

export { ThemeDarkValues, ThemeLightValues };
